// ui/src/Forms/Loaders/components/AddressSkeleton.js
import { Mui } from "@osu/react-ui";

function AddressSkeleton() {
  return (
    <Mui.Box sx={{ mb: 3 }}>
      <Mui.Skeleton variant="text" width="30%" height={28} sx={{ mb: 2 }} />
      
      {/* Address line 1 & 2 */}
      <Mui.Box sx={{ mb: 2 }}>
        <Mui.Skeleton variant="text" width="25%" height={24} />
        <Mui.Skeleton variant="rectangular" width="100%" height={56} />
      </Mui.Box>
      <Mui.Box sx={{ mb: 2 }}>
        <Mui.Skeleton variant="text" width="25%" height={24} />
        <Mui.Skeleton variant="rectangular" width="100%" height={56} />
      </Mui.Box>
      
      {/* State, zip, country in a row */}
      <Mui.Box sx={{ display: 'flex', gap: 2 }}>
        <Mui.Box sx={{ flex: 1 }}>
          <Mui.Skeleton variant="text" width="60%" height={24} />
          <Mui.Skeleton variant="rectangular" width="100%" height={56} />
        </Mui.Box>
        <Mui.Box sx={{ flex: 1 }}>
          <Mui.Skeleton variant="text" width="40%" height={24} />
          <Mui.Skeleton variant="rectangular" width="100%" height={56} />
        </Mui.Box>
        <Mui.Box sx={{ flex: 1 }}>
          <Mui.Skeleton variant="text" width="50%" height={24} />
          <Mui.Skeleton variant="rectangular" width="100%" height={56} />
        </Mui.Box>
      </Mui.Box>
    </Mui.Box>
  );
}

export default AddressSkeleton;
